import { Panel } from '../../../components/Panel'

/** A tab (or panel) whose data source the title does not have yet; the text comes from the API. */
export function NotYetLive({ text }: { text: string }) {
  return (
    <Panel accent="none">
      <p className="text-paper">{text}</p>
    </Panel>
  )
}
